(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /* Las píldoras abren el cajón de filtros con on:click; aquí solo se decide
     qué filtro queda abierto dentro: el que se pulsó, y los demás plegados.
     Va delegado en document porque facets.js reemplaza la barra entera cada
     vez que se aplica un filtro. */
  document.addEventListener('click', (event) => {
    const boton = event.target.closest('[data-abrir-filtro]');
    if (!boton) return;

    requestAnimationFrame(() => {
      const cajon = document.getElementById('filters-drawer');
      if (!cajon) return;

      const id = boton.dataset.abrirFiltro;
      cajon.querySelectorAll('details.facets__panel').forEach((detalles) => {
        detalles.open = detalles.id === id;
      });
      cajon.querySelector(`#${CSS.escape(id)}`)?.scrollIntoView({ block: 'start' });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["history"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(scope){
    (scope || document).querySelectorAll('.stories-video').forEach(function(root){
      if(root.dataset.svInit) return;
      root.dataset.svInit = '1';
      var tpl = root.querySelector('[data-sv-tpl]');
      var modal = root.querySelector('[data-sv-modal]');
      var stage = root.querySelector('[data-sv-stage]');
      var openBtn = root.querySelector('[data-sv-open]');
      if(!tpl || !modal || !stage || !openBtn) return;

      function open(){
        stage.innerHTML = '';
        stage.appendChild(tpl.content.cloneNode(true));
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        var v = stage.querySelector('video');
        if(v){ v.currentTime = 0; v.play().catch(function(){}); }
      }
      function close(){
        var v = stage.querySelector('video');
        if(v) v.pause();
        stage.innerHTML = '';
        modal.hidden = true;
        document.body.style.overflow = '';
      }

      openBtn.addEventListener('click', open);
      modal.querySelectorAll('[data-sv-close]').forEach(function(el){ el.addEventListener('click', close); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !modal.hidden) close(); });
    });
  }
  if(document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
  } catch(e) { console.error(e); }
})();

})();
